// extracted by mini-css-extract-plugin
export default {"rating":"PA-z","numberOfStars":"QA-z","count":"RA-z","barGraphSpacing":"SA-z","barGraph":"TA-z"};